interface PostHogCaptureLike {
  event: string;
  properties: Record<string, unknown>;
  $set?: Record<string, unknown>;
  $set_once?: Record<string, unknown>;
}

const SATELLITE_PAGE_LOAD_PROPERTIES = new Set([
  "$token",
  "$lib",
  "$lib_version",
  "$insert_id",
  "$time",
  "$config_defaults",
  "app",
  "application",
  "tenant_key",
  "route_template",
  "navigation_type",
  "duration_ms",
  "loading_ui_appeared",
  "terminal_outcome",
  "release",
]);

/**
 * Remove PostHog's automatic page, host, referrer, device, and person fields
 * from the tenant-safe navigation event before it leaves the browser.
 */
export function sanitizeSatellitePageLoadCapture<
  T extends PostHogCaptureLike,
>(capture: T): T {
  if (capture.event !== "satellite_page_load") return capture;

  const properties = Object.fromEntries(
    Object.entries(capture.properties).filter(([key]) =>
      SATELLITE_PAGE_LOAD_PROPERTIES.has(key),
    ),
  );

  properties.distinct_id = properties.tenant_key;
  properties.$process_person_profile = false;

  const sanitized = { ...capture, properties };
  delete sanitized.$set;
  delete sanitized.$set_once;
  return sanitized;
}
